var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor"},[_c('ckeditor',{ref:_vm.id,attrs:{"id":_vm.id,"value":_vm.value,"editor":_vm.editor,"config":_vm.editorConfig},on:{"input":_vm.handleContent,"ready":_vm.onEditorReady}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }